import { getDocumentElement } from './document';
import { getWindow } from './window';
export var scrollPosition = function (element) {
    var documentElement = getDocumentElement(element);
    var win = getWindow(element);
    return {
        x: win.pageXOffset || documentElement.scrollLeft || 0,
        y: win.pageYOffset || documentElement.scrollTop || 0
    };
};



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/scroll-position.js
// module id = 217
// module chunks = 93